<template>
    <df-app no-padding title="MySolutions">
        <template slot="aside" v-if="rows">
            <ul class="nav nav-pills nav-stacked">
                <component :is="navItem('default')"/>
                <component :is="navItem('owner')"/>
            </ul>
            <div class="aside-compose"><router-link :to="{ name: 'create-solution' }" class="btn btn-lg btn-primary btn-block">Solution hinzufügen</router-link></div>
            <span class="title text-uppercase">Zu Bearbeiten</span>
            <ul class="nav nav-pills nav-stacked">
                <component :is="navItem('new')"/>
            </ul>
        </template>

        <router-view :rows="filteredRows" :allRows="rows" :title="title" :icon="icon" @reload="load" @update="update" v-if="rows"/>
    </df-app>
</template>

<script>
    import admin from '../../../mixins/admin';
    import Solution from '../../../models/Solution';

    export default {
        mixins: [admin],

        data: vm => ({
            Model: Solution,

            route: 'admin-solutions',
            filters: {
                default: { title: 'Alle Solutions', icon: 'graduation-cap', filter: s => s.hasCategories },
                owner: {
                    title: 'Meine Solutions',
                    icon: 'account',
                    filter: s => (s.hasCategories && s.isOwner),
                },
                new: {
                    title: 'Solutions ohne Kategorisierung',
                    navTitle: 'Ohne Kategorisierung',
                    icon: 'star',
                    filter: s => !s.hasCategories,
                },
            },
        }),
    };
</script>
